import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Button } from 'uiKit/atoms/Button/Button';
import { useFormikContext } from 'formik';
import { ReactComponent as PreviewEyeSVG } from '../../assets/img/preview-eye.svg';
import { protectedRoutes, ModalsList } from '../../constants';
import { useStores } from '../../stores';
import BackHeader from 'components/BackHeader/BackHeader';

import styles from './ControlPanel.module.scss';

const ControlPanel = ({ submitHandler, saveHandler, handlePreviewClick, isPreview }) => {
  const { modalStore, singleLotStore } = useStores();
  const { isValid } = useFormikContext();
  const { showModal } = modalStore;

  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isNewLot = location.pathname === protectedRoutes[3];
  const { isDraft } = singleLotStore;

  const confirmCancelation = () => {
    if (location.key) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  const handleCancelButtonClick = () => {
    showModal(ModalsList.CancelationModal.name, confirmCancelation);
  };

  const isPreviewDisabled = Boolean(
    isValid 
  );

  return (
    <div className={styles.bns3_add_page_control_panel_container}>
      {isPreview ? (
        <BackHeader title="Back To The Creation" onBack={handlePreviewClick} />
      ) : (
        <>
          <h1 className={styles.bns3_add_page_title}>{!params.id ? 'New Lot' : 'Edit Lot'}</h1>

          <div className={styles.bns3_add_page_controls_container}>
            <div className={styles.bns3_add_page_button_container}>
              <Button type="text" onClick={handleCancelButtonClick} className={styles.bns3_add_page_cancel_button}>
                Cancel
              </Button>
            </div>

            <div className={cn(styles.bns3_add_page_button_container, styles.bns3_add_page_draft_button_container)}>
              {(isNewLot || isDraft) && (
                <Button
                  type="contained"
                  className={styles.bns3_add_page_draft_button}
                  onClick={() => {
                    saveHandler();
                  }}
                  sx={{ ':hover': { background: 'none' } }}
                >
                  Save As Draft
                </Button>
              )}
            </div>
            {/* PREVIEW BUTTON */}
            <div className={styles.bns3_add_page_button_container}>
              <Button
                variant="text"
                startIcon={<PreviewEyeSVG style={{ display: 'flex', marginRight: '10px' }} />}
                onClick={handlePreviewClick}
                className={styles.bns3_add_page_preview_button}
                disabled={!isPreviewDisabled}
                sx={{
                  '&.Mui-disabled': {
                    borderColor: 'rgba(255,255,255,0.4)',
                    color: 'rgba(255,255,255,0.4)',
                    cursor: 'not-allowed',
                    pointerEvents: 'auto',
                  },
                }}
              >
                PREVIEW
              </Button>
            </div>

            <div className={styles.bns3_add_page_button_container}>
              <label
                tabIndex="0"
                  onClick={() => {
                  submitHandler();
                }}
                className={styles.bns3_add_page_publish_button}
              >
                PUBLISH
              </label>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

ControlPanel.propTypes = {
  submitHandler: PropTypes.func,
  saveHandler: PropTypes.func,
  handlePreviewClick: PropTypes.func,
  isPreview: PropTypes.bool,
  singleLotStore: PropTypes.shape({
    singleLot: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
};

export default observer(ControlPanel);
